import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-05038c8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component icubox" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-05038c8b><mask id=\"mask0_1236_1680\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" data-v-05038c8b><rect width=\"20\" height=\"20\" fill=\"#D9D9D9\" data-v-05038c8b></rect></mask><g mask=\"url(#mask0_1236_1680)\" data-v-05038c8b><path d=\"M9.16667 17.5V12.5H10.8333V14.1667H17.5V15.8333H10.8333V17.5H9.16667ZM2.5 15.8333V14.1667H7.5V15.8333H2.5ZM5.83333 12.5V10.8333H2.5V9.16667H5.83333V7.5H7.5V12.5H5.83333ZM9.16667 10.8333V9.16667H17.5V10.8333H9.16667ZM12.5 7.5V2.5H14.1667V4.16667H17.5V5.83333H14.1667V7.5H12.5ZM2.5 5.83333V4.16667H10.8333V5.83333H2.5Z\" fill=\"white\" data-v-05038c8b></path></g></svg>", 1)
const _hoisted_3 = {
  key: 0,
  class: "icu-list-box contents__box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "중환자실 선택"),
  /*#__PURE__*/_createElementVNode("h4", null, "(1개 이상 필수 선택)")
], -1))
const _hoisted_5 = { class: "content-box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"check__box\" data-v-05038c8b><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-05038c8b><mask id=\"mask0_1239_10342\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-05038c8b><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-05038c8b></rect></mask><g mask=\"url(#mask0_1239_10342)\" data-v-05038c8b><path d=\"M6.36689 12.0001L2.56689 8.20007L3.51689 7.25007L6.36689 10.1001L12.4836 3.9834L13.4336 4.9334L6.36689 12.0001Z\" fill=\"white\" data-v-05038c8b></path></g></svg></div>", 1)
const _hoisted_8 = { class: "check__box_option" }
const _hoisted_9 = { class: "btn__box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["icu-box contents__box", [{'active':_ctx.icuPopupIsOpen}, {'selected':_ctx.btnActive&&!_ctx.allSelected}]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleIcuBox()))
    }, [
      _hoisted_2,
      _createElementVNode("h3", null, _toDisplayString(_ctx.text), 1)
    ], 2),
    (_ctx.icuPopupIsOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "close-btn",
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleIcuBox()))
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icuTemp, (icu) => {
              return (_openBlock(), _createElementBlock("div", {
                key: icu,
                class: _normalizeClass({'checked':icu.checked}),
                onClick: ($event: any) => (_ctx.checkIcu(icu))
              }, [
                _hoisted_7,
                _createElementVNode("h3", _hoisted_8, _toDisplayString(icu.name), 1)
              ], 10, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["button__blue", {'inactive':!_ctx.btnActive}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setIcu()))
            }, "적용", 2),
            _createElementVNode("button", {
              class: "button__navy",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectAll()))
            }, "전체 선택")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}